// pages/sections/MirrorNote.js
// "PE data as of …" line for sections built from the pe.* mirror, with a warning
// when the mirror sync is overdue. `mirror` = { lastSyncUtc, overdue } from the API.
import React from 'react';

export default function MirrorNote({ mirror, staleHint = 'recent PE changes might not show yet.' }) {
  // The "PE data as of …" timestamp is no longer shown; only the overdue-sync warning remains.
  if (!mirror || !mirror.overdue) return null;
  return (
    <div className="rt-mirror-note">
      <span className="rt-mirror-warn">
        <i className="fas fa-exclamation-triangle" /> PE data may be stale — {staleHint}
      </span>
    </div>
  );
}
